import { styled } from '@mui/system';
import { Box, Tabs, Tab } from '@mui/material';

export const TabsBox = styled(Box)(() => ({
  width: '100%'
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'center'
  },
  '& .MuiTabs-indicator': {
    display: 'none'
  }
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  flex: '1',
  minWidth: 0,
  maxWidth: 'none',
  borderRadius: 0,
  '&.outer': {
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px'
  },
  '&.inner': {
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px'
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.secondary.main,
    color: 'white'
  },
  '&:not(.Mui-selected)': {
    backgroundColor: 'white'
  },
  '&:not(:first-of-type)': {
    marginLeft: '5px'
  }
}));
